import request from '@/shared/api/request';

/**
 *
 * Returns csrftoken (dev only).
 *
 * @returns {Promise}
 */
export const getCSRFToken = (): Promise<{ csrf_token: string }> =>
  request({
    url: '/account/login/',
    method: 'GET',
  });
